var Marionette = require('marionette');
var Lookups = EY.Consultation.Lookups;

var Router = Marionette.AppRouter.extend({
    appRoutes: {
        '': 'home',
        'Administration/UserManagement': 'manage',
        'Administration/UserProfile/:id': 'userProfile',
        'Administration/Questionnaire/:id': 'questionnaire',
        'Administration/Questionnaires': 'questionnaires',
        'CountryRecord/:area/:region/:country/:id': 'redbox',
        'Administration/Classification': 'classification',
        'Record/:id': 'record',
        'RecordCreate': 'create',
        'Test/:type': 'test'
    },
    controller: {
        home: function () {
            require('Home').start();
        },
        create: function () {
            require('RecordCreate').start();
        },
        manage: function () {
            require('UserManagement').start();
        },
        questionnaire: function (id) {
            var entities = require('Entities');
            var questionnaire = new entities.Questionnaire({ id: id });

            questionnaire.fetch().done(function () {
                require('Questionnaire').start({ questionnaire: questionnaire });
            });
        },
        questionnaires: function () {
            require('Questionnaires').start();
        },
        classification: function() {
            require('Classification').start();
        },
        record: function (id) {
            var entities = require('Entities');
            var record = new entities.Record({ id: id });

            record.fetch({
                data: {
                    'zoneKey': 0
                }
            }).done(function (found) {
                found ? require('Record').start({ record: record }) : window.location = 'Consultation/Error?culture=' + EY.Consultation.CurrentCulture;
            });
        },
        redbox: function (area, region, country, id) {
            var entities = require('Entities');
            var record = new entities.Record({ id: id });
            var zoneKey = Lookups.RedBoxCountryZone['/' + area + '/' + region + '/' + country + '/'];
            var location = Lookups.RedBoxLocation['/' + area + '/' + region + '/' + country + '/'];
            record.urlRoot = Lookups.RedBoxCountryApi['/' + area + '/' + region + '/' + country + '/'] + 'Record';

            record.fetch({
                data: {
                    'zoneKey': zoneKey,
                    'location': location
                }
            }).done(function (found) {
                found ? require('Record').start({ record: record }) : window.location = 'Consultation/Error?culture=' + EY.Consultation.CurrentCulture;
            });
        },
        test: function (type) {
            require('testbench').run({
                type: type
            });
        },
        userProfile: function (id) {
            var entities = require('Entities');
            var user = new entities.User({ id: id });

            user.fetch().done(function (found) {
                found && require('UserProfile').start({ user: user });
            });
        }
    },
    navigate: function (route) {
        if (route === Backbone.history.fragment) {
            Marionette.AppRouter.prototype.navigate.call(this, '', { replace: false });
        } // Backbone.Router.navigate prematurely returns if the same URL fragment is being re-routed!
        Marionette.AppRouter.prototype.navigate.apply(this, arguments);
    }
});

module.exports.navigate = new Router().navigate;


// WEBPACK FOOTER //
// ./js/Modules/Application/Router.js